import RestClient from './RestClient';
import { Ticket } from '../../models';

class Tickets extends RestClient {
    constructor() {
        super({
            "model": Ticket,
            "entryPoint": "ticket",
            "resource": "ticket",
            "resources": "tickets",
            "id_field": "_id"
        });
    }

    importTickets(data) {
        const payload = data?.length > 0 ? { data } : {};

        return this.POST('/ticket/import', payload)
            .then(response => response.json())
            .then(json => {
                if (json.imported)
                    return json;
                throw new Error(json.flash.error);
            });
    }

    updateWallets(ids, mode, amount) {
        const payload = { ids, mode, amount };

        return this.POST('/ticket/wallet', payload)
            .then(response => response.json())
            .then(json => {
                if (json.wallets)
                    return json;
                throw new Error(json.flash.error);
            });
    }
}

const TicketsApi = new Tickets();

export default TicketsApi;
